/**
 * TYPINGS
 */
interface IParams {
  totalSolicitacoes: number;
  qtdCsv: number;
  qtdZip?: number | null;
}

interface IResultado {
  valido: boolean;
  divergencias: string[];
  mensagem: string;
}

/**
 * Valida se total de solicitações, registros da planilha e arquivos no ZIP coincidem.
 * Espelha a lógica de negócio do backend (RemessaService::validarConsistenciaArquivosRemessa).
 */
function validarConsistenciaArquivosRemessa({
  totalSolicitacoes,
  qtdCsv,
  qtdZip = null,
}: IParams): IResultado {
  const divergencias: string[] = [];

  if (totalSolicitacoes !== qtdCsv) {
    divergencias.push(
      `total de solicitações (${totalSolicitacoes}) difere da planilha (${qtdCsv})`
    );
  }

  if (qtdZip !== null) {
    if (totalSolicitacoes !== qtdZip) {
      divergencias.push(`total de solicitações (${totalSolicitacoes}) difere do ZIP (${qtdZip})`);
    }
    if (qtdCsv !== qtdZip) {
      divergencias.push(`planilha (${qtdCsv}) difere do ZIP (${qtdZip})`);
    }
  }

  if (divergencias.length === 0) {
    return { valido: true, divergencias, mensagem: "" };
  }

  return {
    valido: false,
    divergencias,
    mensagem:
      "Inconsistência na remessa: " +
      divergencias.join("; ") +
      ". Verifique se total, planilha e ZIP têm a mesma quantidade.",
  };
}

export type { IParams, IResultado };
/**
 * EXPORTS
 */
export { validarConsistenciaArquivosRemessa };
